
// Example usage:
// const log = Log(Log.INFO);
// log.warn("This isn't going well.");

class Log {
  static get DEBUG() { return 0;}
  static get INFO()  { return 1;}
  static get WARN()  { return 2;}
  static get ERROR() { return 3;}

  constructor(level) { this.level = level | 0; }
  show(msg, obj, msgLevel, msgLevelString) {
    if (msgLevel >= this.level) {
        console.log(msgLevelString + msg);
        if (obj !== undefined) {
            console.log(obj);
        }
    }
  }
  debug(msg, obj) { this.show(msg, obj, Log.DEBUG, "[DEBUG] "); }
  info(msg, obj)  { this.show(msg, obj, Log.INFO,  "[INFO]  "); }
  warn(msg, obj)  { this.show(msg, obj, Log.WARN,  "[WARN]  "); }
  error(msg, obj) { this.show(msg, obj, Log.ERROR, "[ERROR] "); }
}

export {Log};



// WEBPACK FOOTER //
// ./src/log.js